import ChangeVIN from './ChangeVIN';

export default ChangeVIN;
